import { render, staticRenderFns } from "./store-website.vue?vue&type=template&id=22d262c4&"
import script from "./store-website.vue?vue&type=script&lang=js&"
export * from "./store-website.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports